import React from 'react';

export default function SpriteIcons({ ClassIcon = "SpriteIcons" }) {
  return (
    <>
      <div className="BoxIcons"></div>
    </>
  );
}